import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ImageIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 23 22">
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.3125 17.1875H17.8993L14.0121 12.0037L10.4165 16.5522L8.01025 13.6441L5.3125 17.1875ZM0.5 22V0H22.5V22H0.5ZM1.875 20.625H21.125V1.375H1.875V20.625ZM6.68475 7.5625C7.06608 7.5625 7.39104 7.42912 7.65962 7.16237C7.92821 6.89562 8.0625 6.57158 8.0625 6.19025C8.0625 5.80892 7.92912 5.48396 7.66237 5.21538C7.39562 4.94679 7.07158 4.8125 6.69025 4.8125C6.30892 4.8125 5.98396 4.94587 5.71538 5.21263C5.44679 5.47937 5.3125 5.80342 5.3125 6.18475C5.3125 6.56608 5.44587 6.89104 5.71263 7.15962C5.97937 7.42821 6.30342 7.5625 6.68475 7.5625Z" fill="#768f77" />
    </svg>
  </SvgIcon>
);

export default ImageIcon;
